import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

// New Issue
// Routine for Form
export const submitIssueFormNewRoutine = createRoutine('SUBMIT_ISSUE_FORM_NEW')
export const submitIssueFinalFormNewHandler = promisifyRoutine(submitIssueFormNewRoutine)

// Delete Issue
export const submitIssueFormDeleteRoutine = createRoutine('SUBMIT_ISSUE_FORM_DELETE')
